import { createContext } from "react";
import { SubscriptionPlanModel } from "@jugl-web/rest-api/entities/models/SubscriptionPlan/SubscriptionPlanModel";
import { UpdateCardAlertResult } from "./components/UpdateCardAlert";

export interface EntitySubscriptionContextValue {
  navigateToManageSubscription: () => void;
  updateCardDetails: () => Promise<UpdateCardAlertResult>;
  changeSubscription: (
    plan: SubscriptionPlanModel,
    seatsCount: number,
    promoCode?: string
  ) => void;
  applyAppSumoSubscription: (planId: string, codes: string[]) => void;
  retryLastInvoicePayment: () => Promise<void>;
  isRetryInvoiceLoading: boolean;
  isCardPaymentNotSupported: boolean;
}

export const EntitySubscriptionContext =
  createContext<EntitySubscriptionContextValue | null>(null);
